<template>
  <div class="tw-w-64 tw-mr-6 transition-medium">
    <div
      :class="borderClass"
      class="tw-h-64 tw-flex"
      :style="thumbnailBackground"
    >
      <div
        class="actionWrapper tw-h-full tw-w-full tw-relative"
        @mouseover="buttonVisible = true"
        @mouseleave="buttonVisible = false"
      >
        <div
          class="tw-absolute tw-pin-t tw-pin-r tw-text-success tw-mt-4 tw-mr-5 animated fadeIn"
          v-if="selected"
        >
          <i class="fa fa-check-circle"></i>
        </div>
        <div
          class="tw-h-full tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center animated fadeIn"
          v-if="buttonVisible"
        >
          <button
            class="tw-border tw-border-white tw-py-2 tw-w-32 tw-text-white tw-rounded-lg tw-mb-4"
            @click="preview"
          >Preview
          </button>
          <button
            class="tw-border tw-border-white tw-py-2 tw-w-32 tw-text-white tw-rounded-lg"
            @click="changeStatus('selected')" v-if="!selected"
          >Select
          </button>
          <button
            class="tw-border tw-border-white tw-py-2 tw-w-32 tw-text-white tw-rounded-lg"
            @click="changeStatus('deselected')" v-if="selected"
          >Deselect
          </button>
        </div>
      </div>
    </div>
    <div
      class="media-card-element__description tw-mt-2 tw-text-base tw-text-grey-darker tw-w-full"
    >
      {{ video.description }}
    </div>
    <div class="tw-flex tw-justify-between tw-text-grey tw-font-thin tw-text-base">
      <span>Uploaded:</span>
      <span v-text="video.uploaded_at"></span>
    </div>
  </div>
</template>

<script>
  import mediaMixin from '../media';

  export default {
    name: 'MediaElement',

    mixins: [
      mediaMixin,
    ],

    data() {
      return {
        buttonVisible: false,
      };
    },

    computed: {
      thumbnailBackground() {
        return {
          backgroundImage: `url(${ this.video.thumbnail })`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'auto 160px',
        };
      },

      borderClass() {
        return this.selected
          ? 'tw-border-4 tw-border-success'
          : 'tw-border tw-border-grey-lighter';
      },
    },

    methods: {
      preview() {
        this.$emit('preview', this.video.id);
      },
    },
  };
</script>

<style lang="scss">
  .media-card-element {
    &__description {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .actionWrapper {
    transition: all .5s;
  }

  .actionWrapper:hover {
    background-color: rgba(0, 0, 0, .5);
  }
</style>
